package com.bikompanion.domain

data class PendingVoteFlushResult(
    val sentCount: Int,
    val rejectedCount: Int,
    val hasPendingVotes: Boolean,
)
